import React from 'react';
import type { useForm } from 'react-hook-form';

import { TextField, ControlledSelect } from '@seuk/design-system/molecules';

import type { IndustrySectorFormValues } from '../forms/types';

export interface IndustrySectorProps {
  methods: unknown;
  //methods: ReturnType<typeof useForm>;
}

const INDUSTRY_SECTOR = [
  'Please select...',
  'Agriculture & Farming',
  'Business & Financial Services',
  'Construction',
  'Data centres',
  'Education',
  'Food Manufacturing',
  'Food Wholesale',
  'Healthcare',
  'Heavy Manufacturing / Industry',
  'Leisure/Tourism/Hotels',
  'Manufacturing',
  'Media / Telecoms',
  'Pharmaceuticals',
  'Property Mgmt/Landlords',
  'Public Bodies / Charities',
  'Restaurants / Pubs / Bars',
  'Retail',
  'Transport & Distribution',
  'Wholesale',
  'Other – please specify',
] as const;

const INDUSTRY_SECTOR_ITEMS = INDUSTRY_SECTOR.map((sector) => {
  return {
    label: sector,
    value: sector,
  };
});

const INDUSTRY_SECTOR_OTHER = 'Other – please specify';

export const IndustrySector = ({ methods: formMethods }: IndustrySectorProps) => {
  // todo fix methods types
  const methods = formMethods as ReturnType<typeof useForm<IndustrySectorFormValues>>;
  const industrySector = methods.watch('industrySector');

  return (
    <>
      <ControlledSelect
        label="Industry sector*"
        name="industrySector"
        id="industrySector"
        rules={{
          validate: (value) => {
            return value && value !== INDUSTRY_SECTOR[0] ? true : 'Please select your areas of interest';
          },
        }}
        items={INDUSTRY_SECTOR_ITEMS}
      />
      {industrySector === INDUSTRY_SECTOR_OTHER && (
        <TextField id="industrySectorOther" label="Please specify" {...methods.register('industrySectorOther')} />
      )}
    </>
  );
};
